import React, { Component } from "react"
import { observer } from "mobx-react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Card, Icon, Button, Input, Label, Reveal, Image, Dropdown } from "semantic-ui-react"
import Price from "components/Price/Price"
import ButtonLove from "components/Button/ButtonLove"
import shop from "shop/shop"
import "components/Product/ProductCard.scss"
import Responsive from "react-responsive"
import ImageWithFallback from "components/ImageWithFallback"
import Badge from "components/Product/Badge";

@observer
class ProductCard extends Component {


  render() {
    let { product, categoryId = "" } = this.props
    const inCart = shop.cart.productsById.get(product.map_id)
    const useQuickorder = shop.config.plugin.orderFromTile && shop.session

    if (!product) return <div>LOADING</div>

    return (
      <Card className="product ProductCard hide-child">

        <div className="wrapper relative">
          {/* CARD B: NOT HOVER */}
          {/*<pre className="absolute top-0 left-0 right-0 f6 bg-black white">{JSON.stringify( {sort: product.sort}, null, 2 )}</pre>*/}
          <Link className="product-inner"
            to={`/product/${product.map_id}/?category=${categoryId}`}>
            <div className="image flex items-center justify-center">
              <ImageWithFallback

                src={product.img_src_medium}
                alt="..."
                title=""
                className="img-responsive pt4" />
            </div>
            <div className="caption pt2">
              <div className="title" title={product.title}>{product.title}</div>
              <div className="category black-50 f6" title={product.category.title}>
                <div> {product.article_nr} </div>
              </div>

              {/*{(inCart && inCart.count > 0) && <div className="absolute top-1 left-1 f6 black-40 ">*/}
              {/*  <Icon name={"shopping cart"}/> {inCart.count * inCart.unit_multi} Stück*/}
              {/*</div>}*/}

              <div className="actions">
                {(this.props.list) ? <ButtonLove list={this.props.list}
                  product={product}><Icon
                    name={"heart"} /></ButtonLove> : null} </div>

            </div>
          </Link>

          <div className="absolute top-1 right-1">
            <ButtonLove list={shop.orderlist.default}
              className="dib mr3"
              elementInActive={<span><Icon name={"heart outline"} /></span>}
              elementActive={<span><Icon name={"heart"} /></span>}
              product={product} />
          </div>


          {this.props.children}

          <div className="badges absolute left-1 top-1 black-50 ">
            <div className="flex flex-row">
              {/*{product.extras.gc_rabatt && <Label className={"giftcardPercent"} color="red">COUPON {product.extras.gc_rabatt} %</Label>}*/}
              {product.pinfos.gc_rabatt && <div title={translate("Coupon-Rabatt")} className="mr1 pb2"><Label className={"giftcardPercent"} color="red"><span className="ttu">-{product.pinfos.gc_rabatt} %</span></Label></div>}
              {product.isSale && <div title={translate("Ihr Kundenrabatt")} className="pb2"><Label className={"salePercent"} color="red">-{product.salePercent}</Label></div>}
            </div>
            <div className="flex flex-row items-center">
              <div className="availability tl">{product.getNotice("tiny", Number(product.stock))}</div>
              {product.extras && product.extras.Neuheit && product.extras.Neuheit.value && product.extras.Neuheit.value.value && <span className="labelNeu1">&nbsp;&nbsp;{translate("Neu")}&nbsp;&nbsp;</span>}
              <Badge product={product} />
            </div>

            {/*TODO: TEST VISUALLY */}
            {/*{inCart ? <div className={"white"}><Icon name="shopping cart"/> {inCart.count * inCart.unit_multi} Stück</div>*/}
            {/*  : <div><Icon name="shopping cart"/> 0 Stück</div>*/}
            {/*}*/}
          </div>

          {shop.session ? <div>
            <div className="absolute right-1 bottom-1">

              <Button primary className="" basic icon={"cart"} onClick={() => {
                if (product.count) {
                  product.count += 1
                } else {
                  product.count = 1
                }
                shop.cart.add(product)
                shop.toast(`${product.count} ${product.unit_desc} x ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom")
              }} />
            </div>
            {product.isSale &&
              <div className="price absolute bottom-1 left-1 color" title={translate("Stückpreis")}>
                {/*<span className="unit_multi black-70 f6 pb2 fw2">Stückpreis</span><br/>*/}
                <span className="f5 black-60 strike"><Price>{product.pinfos.brutto}</Price></span> <br />
                <span className="f5 red b"><Price>{product.price}</Price></span>
              </div>}
            {!product.isSale &&
              <div className="price absolute bottom-1 left-1 color">
                <span className="unit_multi black-70 f6 pb2 fw2"></span><br />
                {/*<span className="unit_multi black-70 f6 pb2 fw2">{translate( "PRODUCT_CARD_PRICE_PREFIX" )}</span><br/>*/}
                <span className="f5  b"><Price>{product.price}</Price></span>
              </div>}
          </div> : <div className="absolute right-1 bottom-1 left-1">
            <Link to={`/login/?referrer=/product/${product.map_id}`}> <Button fluid basic>{translate("Preise anzeigen")}</Button></Link>
          </div>
          }
        </div>


        {/*CARD A:  ON HOVER */}
        {useQuickorder && <div className="hover-card pa3 child absolute left-0 right-0 top-0 bottom-0  z-9  bg-darken">

          <div className="">

            <div className="absolute top-1 right-1">
              <ButtonLove list={shop.orderlist.default}
                className="dib mr3 f4"
                elementInActive={<span><Icon name={"heart"} /></span>}
                elementActive={<span><Icon name={"heart"} /></span>}
                product={product} />
            </div>


            <div className="tc product-link">
              <Button circular as={Link} to={`/product/${product.map_id}/?category=${categoryId}`}>zum
                Produkt</Button>
            </div>

            <div className="bottom-drawer absolute bottom-0 left-0 right-0 bg-white  fadeIn">

              <div className="pa3 absolute bottom-0 left-0 right-0">
                <CardOrder product={product} onChange={() => {
                  this.setState({})
                }} />
              </div>
            </div>
          </div>

        </div>}

      </Card>
    )
  }
}


@observer
class CardOrder extends Component {

  state = {
    count: 0,
    quantity: this.props.product.quantities[0],
    isAdded: false,
    loading: false,
  }

  setQuantity(quantity) {
    this.setState({ quantity }, this.toCart)
  }

  setCount(count) {
    count = Math.max(0, count)
    this.setState({ count }, this.toCart)
  }

  toCart = () => {
    let { quantity, count, isAdded } = this.state
    let { product } = this.props
    if (count > 0) {
      product.count = count
      product.unit_id = quantity.map_desc_id
      product.unit_multi = quantity.multi
      shop.cart.add(product)
      shop.toast(`${product.count}x${product.unit_multi} Stk. ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom")
      this.setState({ product, isAdded: true })
      this.props.onChange && this.props.onChange({ product })
    } else {
      shop.cart.remove(product)
    }
  }

  render() {
    let { quantity, count, isAdded } = this.state
    let { product } = this.props
    const inCart = shop.cart.productsById.get(product.map_id)

    if (!product.canBeBought) return <div>{translate("Nicht verfügbar")}</div>
    return <div className={`CardOrder pt3 ${inCart ? "inCart" : ""}`}>

      <div className="labels ">
      </div>


      <div className="pb3 tc f5-ns f7">
        <Responsive minWidth={"560px"}>
          {product.quantities.length > 3 ?
            <Dropdown
              selection
              fluid
              value={quantity}
              onChange={(e, data) => {
                this.setQuantity(data.value)
              }}
              options={product.quantities.map(q => {
                return {
                  key: q.multi,
                  text: `${q.des} (${q.multi})`,
                  value: q
                }
              })}
            />
            :
            <Button.Group className="quantities" basic size="tiny">
              {product.quantities.map(q => {
                return <Button
                  active={quantity.map_desc_id === q.map_desc_id}
                  key={q.map_desc_id}
                  onClick={() => {
                    this.setQuantity(q)
                    // this.setState( { quantity: q } )
                  }
                  }>{`${q.des} (${q.multi})`}</Button>
              })}
            </Button.Group>
          }

        </Responsive>

        <Responsive maxWidth={"559px"}>
          <Dropdown
            selection
            fluid
            value={quantity}
            onChange={(e, data) => {
              // this.setState( { quantity: data.value } )
              this.setQuantity(data.value)
            }}
            options={product.quantities.map(q => {
              return {
                key: q.multi,
                text: `${q.des} (${q.multi})`,
                value: q
              }
            })}
          />
        </Responsive>


      </div>

      <div className="flex flex-auto w-100  QuickorderTab" style={{ justifyContent: "space-between" }}>
        <Button circular basic floated="right" icon="minus" onClick={() => {
          if (product.count > 0) {
            count -= 1
          } else {
            count = 0
          }
          this.setCount(count)
        }
        } />

        <div className="quickorder-input ">
          <Input type="number" value={count} onChange={e => {
            let count = Math.max(0, Number(e.target.value))
            this.setCount(count)
          }} />
        </div>

        <Button circular basic floated="right" icon="plus" onClick={() => {
          if (count) {
            count += 1
          } else {
            count = 1
          }

          this.setCount(count)
        }
        } />
      </div>

      {/*<div className="tc">*/}
      {/*  <Button*/}
      {/*    color={isAdded ? "green" : "blue"}*/}
      {/*    circular fluid*/}
      {/*    onClick={() => {*/}
      {/*      console.log( "adding", { state: this.state } )*/}
      {/*      this.toCart()*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    {isAdded && <div className={"animate fadeInUp"}>Hinzugefügt</div>}*/}
      {/*    {!isAdded && <span> In den Warenkorb</span>}*/}
      {/*  </Button>*/}
      {/*</div>*/}
    </div>
  }
}

CardOrder.propTypes = { product: PropTypes.any }


ProductCard.defaultProps = {
  quickorder: false
}

ProductCard.propTypes = {
  quickorder: PropTypes.any,
  list: PropTypes.object,
  product: PropTypes.object,
  xs: PropTypes.string,
  sm: PropTypes.string,
  md: PropTypes.string,
  lg: PropTypes.string,
}

export default ProductCard



// WEBPACK FOOTER //
// ./src/theme/giraffiti/components/Product/ProductCard.js